
// // //client/src/App.js
// // import React, { useState } from "react";
// // import UploadPage from "./pages/UploadPage";
// // import ProcessingPage from "./pages/ProcessingPage";
// // import CompletedPage from "./pages/CompletedPage";

// // export default function App() {
// //   const [step, setStep] = useState("upload");
// //   const [files, setFiles] = useState([]);
// //   const [downloadUrl, setDownloadUrl] = useState("");

// //   if (step === "upload") {
// //     return (
// //       <UploadPage
// //         onStart={(selectedFiles) => {
// //           setFiles(selectedFiles);
// //           setStep("processing");
// //         }}
// //       />
// //     );
// //   }

// //   if (step === "processing") {
// //     return (
// //       <ProcessingPage
// //         files={files}
// //         onComplete={(url) => {
// //           setDownloadUrl(url);
// //           setStep("completed");
// //         }}
// //       />
// //     );
// //   }

// //   return <CompletedPage downloadUrl={downloadUrl} />;
// // }



// import React, { useState } from "react";
// import UploadPage from "./pages/UploadPage";
// import ProcessingPage from "./pages/ProcessingPage";
// import CompletedPage from "./pages/CompletedPage";

// export default function App() {
//   const [step, setStep] = useState("upload");
//   const [files, setFiles] = useState([]);

//   const [result, setResult] = useState(null);

//   if (step === "upload") {
//     return (
//       <UploadPage
//         onStart={(selectedFiles) => {
//           setFiles(selectedFiles);
//           setStep("processing");
//         }}
//       />
//     );
//   }

//   if (step === "processing") {
//     return (
//       <ProcessingPage
//         files={files}
//         onComplete={(response) => {
//           setResult(response);
//           setStep("completed");
//         }}
//       />
//     );
//   }

//   return <CompletedPage result={result} />;
// }

// import React, { useState } from "react";

// import HomePage from "./pages/HomePage";

// import UploadPage from "./pages/invoice/UploadPage";
// import ProcessingPage from "./pages/invoice/ProcessingPage";
// import CompletedPage from "./pages/invoice/CompletedPage";

// import PaymentPage from "./pages/payment/PaymentPage";
// import DashboardPage from "./pages/dashboard/DashboardPage";

// export default function App() {

//   const [module, setModule] =
//     useState("home");

//   const [invoiceStep, setInvoiceStep] =
//     useState("upload");

//   const [files, setFiles] =
//     useState([]);

//   const [result, setResult] =
//     useState(null);

//   // HOME
//   if (module === "home") {
//     return (
//       <HomePage
//         onInvoice={() => {
//           setModule("invoice");
//           setInvoiceStep("upload");
//         }}
//         onPayment={() =>
//           setModule("payment")
//         }
//         onDashboard={() =>
//           setModule("dashboard")
//         }
//       />
//     );
//   }

//   // PAYMENT
//   if (module === "payment") {
//     return <PaymentPage />;
//   }

//   // DASHBOARD
//   if (module === "dashboard") {
//     return <DashboardPage />;
//   }

//   // INVOICE UPLOAD
//   if (
//     module === "invoice" &&
//     invoiceStep === "upload"
//   ) {
//     return (
//       <UploadPage
//         onStart={(selectedFiles) => {
//           setFiles(selectedFiles);
//           setInvoiceStep("processing");
//         }}
//       />
//     );
//   }

//   // INVOICE PROCESSING
//   if (
//     module === "invoice" &&
//     invoiceStep === "processing"
//   ) {
//     return (
//       <ProcessingPage
//         files={files}
//         onComplete={(response) => {
//           setResult(response);
//           setInvoiceStep("completed");
//         }}
//       />
//     );
//   }

//   // INVOICE COMPLETED
//   return (
//     <CompletedPage
//       result={result}
//     />
//   );
// }


// // //client/src/App.js
// import { Routes, Route } from "react-router-dom";

// import HomePage from "./pages/HomePage";

// import UploadPage from "./pages/invoice/UploadPage";
// import ProcessingPage from "./pages/invoice/ProcessingPage";
// import CompletedPage from "./pages/invoice/CompletedPage";

// import PaymentPage from "./pages/payment/PaymentPage";
// import DashboardPage from "./pages/dashboard/DashboardPage";

// export default function App() {
//   return (
//     <Routes>

//       <Route
//         path="/"
//         element={<HomePage />}
//       />

//       <Route
//         path="/invoice"
//         element={<UploadPage />}
//       />

//       <Route
//         path="/invoice/process"
//         element={<ProcessingPage />}
//       />

//       <Route
//         path="/invoice/completed"
//         element={<CompletedPage />}
//       />

//       <Route
//         path="/payment"
//         element={<PaymentPage />}
//       />

//       <Route
//         path="/dashboard"
//         element={<DashboardPage />}
//       />

//     </Routes>
//   );
// }



//client/src/App.js

import { Routes, Route } from "react-router-dom";

import HomePage from "./pages/HomePage";

import UploadPage from "./pages/invoice/UploadPage";
import ProcessingPage from "./pages/invoice/ProcessingPage";
import CompletedPage from "./pages/invoice/CompletedPage";

import PaymentHomePage from "./pages/payment/PaymentHomePage";
import PaymentUploadPage from "./pages/payment/PaymentUploadPage";
import PaymentRecordsPage from "./pages/payment/PaymentRecordsPage";

import DashboardPage from "./pages/dashboard/DashboardPage";

export default function App() {

  return (

    <Routes>

      {/* HOME */}

      <Route
        path="/"
        element={<HomePage />}
      />

      {/* INVOICE */}

      <Route
        path="/invoice"
        element={<UploadPage />}
      />

      <Route
        path="/invoice/process"
        element={<ProcessingPage />}
      />

      <Route
        path="/invoice/completed"
        element={<CompletedPage />}
      />

      {/* PAYMENT */}

      <Route
        path="/payment"
        element={<PaymentHomePage />}
      />

      <Route
        path="/payment/upload"
        element={<PaymentUploadPage />}
      />

      <Route
        path="/payment/records"
        element={<PaymentRecordsPage />}
      />

      {/* DASHBOARD */}

      <Route
        path="/dashboard"
        element={<DashboardPage />}
      />

    </Routes>

  );
}